module.exports = __webpack_public_path__ + "static/media/image3.bcefe0f0.png";